export const ERROR_MESSAGES = {
  signIn: 'Invalid email or password',
};


